import {Component, OnDestroy, OnInit} from '@angular/core';
import { NzModalRef, NzMessageService } from 'ng-zorro-antd';
import { _HttpClient } from '@delon/theme';
import {UserService} from "@ecip/service";

@Component({
  selector: 'app-user-local-view',
  templateUrl: './view.component.html',
})
export class UserLocalViewComponent implements OnInit {

  record: any = {};
  i: any;

  constructor(
    private modal: NzModalRef,
    public msgSrv: NzMessageService,
    public userService: UserService
  ) { }

  ngOnInit(): void {
    this.userService.getById(this.record.id).subscribe(res => this.i = res);
  }

  close() {
    this.modal.destroy();
  }

}
